import type Paginated from 'app/core/paginable';
import httpApiApplication, { type HttpApiApplication } from 'app/http/httpApiApplication';
import httpApiSecurity, { type HttpApiSecurity } from 'app/http/httpApiSecurity';

import { type EnvironmentVariable } from '../models/environmentVariable.model';

export const baseUrlEnvironmentVariables = '/environment';

const services: Record<string, HttpApiApplication | HttpApiSecurity> = {
  security: httpApiSecurity,
  application: httpApiApplication
};

const baseUrls: Record<string, string> = {
  security: `v1${baseUrlEnvironmentVariables}`,
  application: baseUrlEnvironmentVariables
};

class EnvironmentVariablesService {
  getExternalWsLoginEnabled(): Promise<EnvironmentVariable> | Promise<any> {
    return services['security']
      .get<EnvironmentVariable>(`v1/environment/getexternalwsloginenabled`)
      .then((response) => ({ response }))
      .catch((error) => ({ error }));
  }

  update(system: string, id?: string, env?: EnvironmentVariable) {
    return services[system].put(`${baseUrls[system]}/${id}`, env);
  }

  create(system: string, env: EnvironmentVariable) {
    return services[system].post(baseUrls[system], env);
  }

  list(
    system: string,
    page: number,
    pageSize: number,
    params: any
  ): Promise<Paginated<EnvironmentVariable>> {
    return services[system].paginate<EnvironmentVariable>(baseUrls[system], page, pageSize, params);
  }
}

export default new EnvironmentVariablesService();
